import { cn } from '@/utils/cn';
import { Check, X, Clock, RefreshCw, AlertTriangle } from 'lucide-react';

interface TimelineEvent {
  status: string;
  label: string;
  date?: string;
  active: boolean;
}

const statusIcons: Record<string, React.ElementType> = {
  PENDING: Clock,
  PROCESSING: Clock,
  APPROVED: Check,
  COMPLETED: Check,
  FAILED: X,
  REFUNDED: RefreshCw,
  CHARGEBACK: AlertTriangle,
  CANCELLED: X,
};

interface PaymentTimelineProps {
  events: TimelineEvent[];
  className?: string;
}

export function PaymentTimeline({ events, className }: PaymentTimelineProps) {
  if (events.length === 0) {
    return <p className="text-sm text-gray-400">Nenhum evento disponível</p>;
  }

  return (
    <div className={cn('space-y-0', className)}>
      {events.map((event, index) => {
        const Icon = statusIcons[event.status] || Clock;
        const isLast = index === events.length - 1;

        return (
          <div key={event.status} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  'w-8 h-8 rounded-full flex items-center justify-center border-2',
                  event.active
                    ? 'bg-primary-50 border-primary-500 text-primary-600'
                    : 'bg-gray-50 border-gray-200 text-gray-400'
                )}
              >
                <Icon size={14} />
              </div>
              {!isLast && (
                <div
                  className={cn(
                    'w-0.5 h-full min-h-[2rem]',
                    event.active ? 'bg-primary-200' : 'bg-gray-200'
                  )}
                />
              )}
            </div>
            <div className={cn('pb-6', isLast && 'pb-0')}>
              <p
                className={cn(
                  'text-sm font-medium',
                  event.active ? 'text-gray-900' : 'text-gray-400'
                )}
              >
                {event.label}
              </p>
              {event.date && (
                <p className="text-xs text-gray-500 mt-0.5">
                  {new Date(event.date).toLocaleString('pt-BR')}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
